// src/utils/axiosConfig.js
import axios from 'axios';
import { addIPInterceptor } from './ipHelper';

// 创建 Axios 实例
const axiosInstance = axios.create({
  baseURL: '/api', // 根据需要调整您的后端 API 基础路径
});

// 添加 IP 攔截器
addIPInterceptor(axiosInstance);

// 添加请求拦截器
axiosInstance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      // 在请求头中添加 Authorization
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// 添加响应拦截器（可选）
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    // 处理 401 未授权错误
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
